import { useCompanyFunction, useRbacPrimaryRolePermissions } from "../../../../../api/hooks";
import { useFeatureFlagQuery } from "../../../../../hooks/useFeatureFlag";

import { CYCLE_TYPE_OPTIONS, type CycleTypeOption } from "../Config";

export const useAvailableCycleTypes = (): {
	options: (CycleTypeOption & { disabled: boolean })[];
	isLoading: boolean;
	isGroupAdminOnly: boolean;
} => {
	const { value: autoflowEnabled } = useFeatureFlagQuery<boolean>("autoflow", false);
	const { value: groupsFlagEnabled } = useFeatureFlagQuery<boolean>("ff-is-groups-enabled", false);
	const { companyFunction: groupsToggle, isLoading: isGroupsLoading } = useCompanyFunction("groups");
	const { data: reviewPermissions, isLoading: isPermissionsLoading } = useRbacPrimaryRolePermissions("review");

	const isLoading = isGroupsLoading || isPermissionsLoading;

	const isGroupAdminOnly =
		!!reviewPermissions &&
		reviewPermissions.includes("review_cycle:createCycle") &&
		!reviewPermissions.includes("review_cycle:editCycle");

	const options = CYCLE_TYPE_OPTIONS.filter((option) => {
		if (isGroupAdminOnly) return option.type === "group";
		if (option.type === "automated") return autoflowEnabled;
		if (option.type === "group") return groupsFlagEnabled;
		return true;
	}).map((option) => ({
		...option,
		disabled: option.type === "group" && groupsFlagEnabled && groupsToggle !== "enabled",
	}));

	return { options, isLoading, isGroupAdminOnly };
};
